// extracted by mini-css-extract-plugin
export default {"page":"BT-z","cartModal":"CT-z","checkout":"DT-z","placeholder":"ET-z","account":"FT-z"};